import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb, faSearch } from "@fortawesome/pro-solid-svg-icons";

import { useDebounce } from "@react-hook/debounce";
import { newSideLoadedBusinessSuggestionsCount } from "selectors";
import { SlimSecondaryButton } from "components/Button";
import SideLoadedBusinessTable from "components/Business/SideLoadedBusinesses/SideLoadedBusinessTable";
import SideLoadFieldCompareModal, {
  SideLoadedSelectValues,
} from "components/Business/SideLoadedBusinesses/CompareModal/SideLoadedFieldCompareModal";
interface SideLoadedBusinessAlertControllerProps {
  searchValues: string;
  ns: string;
  handlePopulateSideloadBusiness: (
    selectedValues: SideLoadedSelectValues,
  ) => void;
  businessId?: string;
  initialOpenState?: boolean;
  initialFieldCompareRecordId?: string;
}

export function SideLoadedBusinessAlertController({
  searchValues,
  handlePopulateSideloadBusiness,
  businessId,
  initialOpenState = false,
  initialFieldCompareRecordId = null,
}: SideLoadedBusinessAlertControllerProps) {
  const [debouncedSearchValue, setDebouncedSearchValue] = useDebounce(
    searchValues,
    300,
  );

  React.useEffect(() => {
    setDebouncedSearchValue(searchValues);
  }, [searchValues, setDebouncedSearchValue]);

  const newSuggestionCount = useSelector(
    newSideLoadedBusinessSuggestionsCount(debouncedSearchValue),
  );

  const hasResults = newSuggestionCount > 0;

  const [fieldCompareRecordId, setFieldCompareRecordId] = useState(
    initialFieldCompareRecordId,
  );

  const [isBrowserOpen, setIsBrowserOpen] = useState(initialOpenState);

  const handleClick = () => {
    setIsBrowserOpen(true);
  };

  const handleSelect = (selectedValues: SideLoadedSelectValues) => {
    setFieldCompareRecordId(null);
    setIsBrowserOpen(false);
    handlePopulateSideloadBusiness(selectedValues);
  };

  return (
    <>
      {hasResults ? (
        <SlimSecondaryButton onClick={handleClick} verticalMargin={2}>
          <FontAwesomeIcon icon={faLightbulb} />
          &nbsp;{newSuggestionCount}&nbsp;suggested
        </SlimSecondaryButton>
      ) : (
        <SlimSecondaryButton onClick={handleClick} verticalMargin={2}>
          <FontAwesomeIcon icon={faSearch} />
          &nbsp;Search suggestions
        </SlimSecondaryButton>
      )}

      {isBrowserOpen && (
        <SideLoadedBusinessTable
          initialSearchTerm={debouncedSearchValue}
          onClose={() => setIsBrowserOpen(false)}
          onSelect={setFieldCompareRecordId}
        />
      )}
      {fieldCompareRecordId && (
        <SideLoadFieldCompareModal
          recordId={fieldCompareRecordId}
          onClose={() => setFieldCompareRecordId(null)}
          businessId={businessId}
          onSelect={handleSelect}
        />
      )}
    </>
  );
}
